import { Component, Inject } from '@angular/core';
import { DwComponent, DwComponentType, DwEventService, DwExpressionService, DwMetaDataService, DwMetaDataServiceToken, DwUIMetaDataConfig, DwUIMetaDataConfigToken, DwUiConfigRegistryService } from '@devwareapps/devware-cap';
import { AppMetaDataItemNames } from '../../../../../meta-data/app-meta-data.service';
import { CourseRepositoryService } from '../../../services/course-repository.service';
import { DwMetaDataFormStateService } from '@devwareapps/devware-cap';
import { CourseStudentProgressFormCardComponent } from '../course-student-progress-form-card/course-student-progress-form-card.component';


@DwComponent({
  key: 'courseStudentProgressFormCardNew',
  name: 'Course Student Progress Card - Form New',
  componentType: DwComponentType.formSection,
  parentItemName: AppMetaDataItemNames.StudentCourse,
  isGlobal: false,
})
@Component({
  selector: 'app-course-student-progress-form-card-new',
  template: `
    <div class="progress-list course-progress-list">
      <app-course-student-progress-card-new [data]="studentCourseProgress"></app-course-student-progress-card-new>
    </div>
  `
})
export class CourseStudentProgressFormCardNewComponent extends CourseStudentProgressFormCardComponent {

  constructor(
    dwExpressionService: DwExpressionService,
    dwUiConfigRegistryService: DwUiConfigRegistryService,
    @Inject(DwUIMetaDataConfigToken) uiMetaDataConfig: DwUIMetaDataConfig,
    @Inject(DwMetaDataServiceToken) dwMetaDataService: DwMetaDataService,
    dwFormStateService: DwMetaDataFormStateService,
    courseRepositoryService: CourseRepositoryService,
    dwEventService: DwEventService,
  ) {
    super(
      dwExpressionService,
      dwUiConfigRegistryService,
      uiMetaDataConfig,
      dwMetaDataService,
      dwFormStateService,
      courseRepositoryService,
      dwEventService
    );
  }

  // Override methods or add new functionality here as needed

}
